//  GNU nano 7.2                                            Login.jsx                                                     import React, { useState } from 'react';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../state/auth.jsx';
import { Eye, EyeOff, Mail, Lock } from 'lucide-react';

export default function Login() {


  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();
  const [showPwd, setShowPwd] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setError('');
    try {
      await login(email, password);
      navigate('/', { replace: true });
    } catch (err) {
      setError(err?.response?.data?.error || err.message || 'Login failed');
    }
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        background: '#f5f7fb',
        padding: 24,
      }}
    >
      <form
        onSubmit={onSubmit}
        style={{
          width: '100%',
          maxWidth: 480,
          display: 'grid',
          gap: 16,
          padding: 28,
          border: '1px solid #e5e7eb',
          borderRadius: 16,
          background: 'white',
          boxShadow: '0 8px 30px rgba(0,0,0,0.06)',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 4 }}>
          <h2 style={{ margin: 0, fontSize: 28, fontWeight: 800, color: '#111827' }}>
            Sign in
          </h2>
          <p style={{ margin: '6px 0 0', color: '#6b7280' }}>
            Access your dashboard
          </p>
        </div>

        {/* Email */}
        <label style={{ fontSize: 14, fontWeight: 600, color: '#374151' }}>
          Email
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'auto 1fr',
              alignItems: 'center',
              gap: 8,
              marginTop: 6,
              border: '1px solid #e5e7eb',
              borderRadius: 12,
              padding: '10px 12px',
              background: '#fff',
            }}
          >
            <Mail size={18} color="#6b7280" />
            <input
              type="email"
              placeholder="you@company.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              style={{
                border: 'none',
                outline: 'none',
                fontSize: 16,
                color: '#111827',
                width: '100%',
                background: 'transparent',
              }}
            />
          </div>
        </label>

        {/* Password with eye toggle */}
        <label style={{ fontSize: 14, fontWeight: 600, color: '#374151' }}>
          Password
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'auto 1fr auto',
              alignItems: 'center',
              gap: 8,
              marginTop: 6,
              border: '1px solid #e5e7eb',
              borderRadius: 12,
              padding: '10px 12px',
              background: '#fff',
            }}
          >
            <Lock size={18} color="#6b7280" />
            <input
              type={showPwd ? 'text' : 'password'}
              placeholder="••••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              style={{
                border: 'none',
                outline: 'none',
                fontSize: 16,
                color: '#111827',
                width: '100%',
                background: 'transparent',
              }}
            />
            <button
              type="button"
              onClick={() => setShowPwd((v) => !v)}
              aria-label={showPwd ? 'Hide password' : 'Show password'}
              style={{
                border: 'none',
                background: 'transparent',
                cursor: 'pointer',
                padding: 4,
                display: 'grid',
                placeItems: 'center',
              }}
            >
              {showPwd ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
        </label>

        {/* Error */}
        {error && (
          <div
            style={{
              color: '#b91c1c',
              background: '#fee2e2',
              border: '1px solid #fecaca',
              padding: '10px 12px',
              borderRadius: 12,
              fontSize: 14,
            }}
          >
            {error}
          </div>
        )}

        {/* Submit */}
        <button
          type="submit"
          style={{
            marginTop: 4,
            background: '#2563eb',
            color: 'white',
            fontWeight: 700,
            border: 'none',
            borderRadius: 12,
            padding: '12px 16px',
            fontSize: 16,
            cursor: 'pointer',
            transition: 'filter .15s ease',
          }}
          onMouseDown={(e) => (e.currentTarget.style.filter = 'brightness(0.95)')}
          onMouseUp={(e) => (e.currentTarget.style.filter = 'none')}
          onMouseLeave={(e) => (e.currentTarget.style.filter = 'none')}
        >
          Login
        </button>
      </form>
    </div>
  );
}
